import React, { Component } from 'react';
import styled from 'styled-components';

import Image from 'partials/Image';
import { h1Styles } from 'partials/typography';
import css from 'css';
import CarearGoal from '../BookMeeting';
import {connect} from "react-redux";

import {
    setBookingGoal,
} from 'store';



class BookMeetingWidget extends Component {
    _onGoalChange(e) {
        this.props.setBookingGoal(e.target.value)
    }
    _goToStep(e){
        console.log("Going to step", e);
    }
    render() {
        const {data, step, goal} = this.props;
        return (
            <BookMeetingLinkWidget>
                <div>
                    {data && <Image image={data}/>}
                    <div>
                        <CarearGoal
                            sideBar
                            step={step}
                            goal={goal}
                            onGoalChange={this._onGoalChange.bind(this)}
                            onNextClick={() => this._goToStep(2)}
                        />
                    </div>
                </div>
            </BookMeetingLinkWidget>
        );
    }
}
const mapStateToProps = state => ({
    step: state.bookMeeting.step,
    goal: state.bookMeeting.goal,
    meetingType: state.bookMeeting.meetingType,
    timeSlot: state.bookMeeting.timeSlot,
    contactDetails: state.bookMeeting.contactDetails,
    fileName: state.bookMeeting.fileName,
    fileLink: state.bookMeeting.fileLink,
});
const actions = {
    setBookingGoal,
}

export default connect(mapStateToProps, actions)(BookMeetingWidget);

const BookMeetingLinkWidget = styled.li`
    position:relative;
    > div {
        margin-bottom:50px;
        img {
            width:100%;
        }
        div {
            
            background: ${css.colors.darkBlue};
            text-align:center;
            strong {
                display:block;
                ${h1Styles};
                font-size:40px!important;
                margin-bottom:40px;
            }
        }
    }
`


// WEBPACK FOOTER //
// ./src/partials/modules/RichText/BookMeetingLinkWidget.js